module.exports = __webpack_public_path__ + "static/img/5.53ac944.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/5.png
// module id = RzEc
// module chunks = 0